module.exports = __webpack_public_path__ + "img/a6.2966ab8e.jpg";